import React from 'react';
import { observer } from 'mobx-react-lite';
import { Badge, Spin } from 'antd';
import { messageModel } from '../MessageModel';
import { formatLastActiveTime } from '../MessageUtil';
import { getPeerUserId } from '../MessageConfig';
import { MessageUnreadBadgeConfig } from '../MessageUIConfig';
import { CachedImage } from '../../components/CachedImage';

export const ChatRoomListPanel: React.FC = observer(() => {
  if (messageModel.loading) {
    return (
      <div className="message-sidebar-loading">
        <Spin />
      </div>
    );
  }

  return (
    <div className="message-room-list">
      {messageModel.sortedRooms.length === 0 && (
        <div className="message-empty-hint">暂无会话</div>
      )}
      {messageModel.sortedRooms.map((room) => {
        const active = messageModel.selectedRoomId === room.id;
        const peerId = getPeerUserId(
          room,
          messageModel.getVisibleMessages(room.id),
        );
        const peerInfo = peerId
          ? messageModel.userInfoCache.get(peerId)
          : undefined;
        const name =
          peerInfo?.name || (room.isGroup ? room.name : '') || room.name || '会话';
        const avatar =
          peerInfo?.avatar || (room.isGroup ? room.avatar : '') || room.avatar;
        return (
          <button
            key={room.id}
            type="button"
            className={`message-room-item${active ? ' active' : ''}`}
            onClick={() => messageModel.selectRoom(room.id)}
          >
            <Badge
              count={room.unreadCount}
              size="small"
              offset={[
                MessageUnreadBadgeConfig.offsetX,
                MessageUnreadBadgeConfig.offsetY,
              ]}
            >
              {avatar ? (
                <CachedImage
                  url={avatar}
                  style={{ width: 44, height: 44, borderRadius: 4 }}
                />
              ) : (
                <div className="message-room-avatar-placeholder" />
              )}
            </Badge>
            <div className="message-room-item-body">
              <div className="message-room-item-top">
                <span className="message-room-name">{name}</span>
                <span className="message-room-time">
                  {formatLastActiveTime(room.lastMessageTime)}
                </span>
              </div>
              <div className="message-room-preview">{room.lastMessage}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
});
